import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';
import logo from '../assets/jnit logo.png';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const menuRef = useRef(null);

  // Navigation items structure
  const navItems = [
    { name: 'Home', href: '/' },
    { name: 'About Us', href: '/about-us' },
    {
      name: 'Services',

      dropdown: [
        'SEO Services',
        'SMM',
        'SEM',
        'Influence Marketing',
        'YouTube Marketing',
        'Lead Generation',
        'App Development'
      ]
    },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact Us', href: '/contact' }
  ];

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        if (isMobileMenuOpen || isServicesOpen) {
          closeAllMenus();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobileMenuOpen, isServicesOpen]);

  // PWA Install Prompt
  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    const handleAppInstalled = () => {
      setShowInstallButton(false);
      setDeferredPrompt(null);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    closeAllMenus();
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (!isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const toggleServicesMenu = (e) => {
    e.stopPropagation();
    setIsServicesOpen(!isServicesOpen);
  };

  const closeAllMenus = () => {
    setIsMobileMenuOpen(false);
    setIsServicesOpen(false);
    document.body.style.overflow = 'auto';
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`} ref={menuRef}>
      <div className="nav-container">
        <div className="nav-logo">
          <img src={logo} alt="JN IT Solutions" className="logo-img" />
          <span className="logo-text">JN IT Solutions</span>
        </div>
        
        <div className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          {navItems.map((item) => (
            <div key={item.name} className={`nav-item ${item.dropdown ? 'has-dropdown' : ''}`}>
              {item.dropdown ? (
                <>
                  <button
                    className={`nav-link ${isServicesOpen ? 'selected' : ''}`}
                    onClick={toggleServicesMenu}
                    aria-expanded={isServicesOpen}
                    aria-controls="services-dropdown"
                  >
                    {item.name}
                  </button>
                  <div
                    id="services-dropdown"
                    className={`dropdown-menu ${isServicesOpen ? 'active' : ''}`}
                  >
                    {item.dropdown.map((service, index) => {
                      const serviceHref = service === 'SEO Services' ? '/seo-services' :
                                         service === 'SMM' ? '/smm' :
                                         service === 'SEM' ? '/sem' :
                                         service === 'Influence Marketing' ? '/influence-marketing' :
                                         service === 'YouTube Marketing' ? '/youtube-marketing' :
                                         service === 'Lead Generation' ? '/lead-generation' :
                                         service === 'App Development' ? '/app-development' :
                                         '#services';
                      return (
                        <Link
                          key={index}
                          to={serviceHref}
                          className="dropdown-item"
                          onClick={closeAllMenus}
                        >
                          {service}
                        </Link>
                      );
                    })}
                  </div>
                </>
              ) : item.name === 'Home' || item.name === 'About Us' || item.name === 'Blog' || item.name === 'Contact Us' ? (
                <Link
                  to={item.href}
                  className="nav-link"
                  onClick={closeAllMenus}
                >
                  {item.name}
                </Link>
              ) : (
                <a
                  href={item.href}
                  className="nav-link"
                  onClick={(e) => handleNavClick(e, item.href)}
                >
                  {item.name}
                </a>
              )}
            </div>
          ))}
          
        </div>

        <button 
          className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
          aria-expanded={isMobileMenuOpen}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
        </button>
      </div>
    </nav>
  );
};

export default Navigation;